import { useIntl } from 'react-intl';
import { Col, Input, Row, Select } from 'antd';

import { ListCustomersQuery } from '@/core/domain/people/Customers/Customers.types';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import ActiveExtraFilter from '@/components/_common/ExtraFilters/ActiveExtraFilter';
import { applyCpfCnpjMask, removeMask } from '@/utils/mask';
import { licensePlateMask } from '@/utils/mask/commonMasks';
import MaskedInput from 'react-text-mask';

function CustomersExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListCustomersQuery>) {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]}>
      <Col span={24} md={8} lg={6} xl={4}>
        <MaskedInput
          value={queryParams?.licensePlate}
          className="ant-input"
          mask={licensePlateMask}
          guide={false}
          name="licensePlate"
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({
              ...prev,
              licensePlate: value.toUpperCase(),
            }))
          }
          placeholder={intl.formatMessage({
            id: 'customers.filters.licensePlate',
          })}
        />
      </Col>

      <Col span={24} md={8} lg={6} xl={4}>
        <Input
          value={applyCpfCnpjMask(queryParams?.cpfCnpj)}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({
              ...prev,
              cpfCnpj: removeMask(value),
            }))
          }
          placeholder={intl.formatMessage({
            id: 'customers.filters.cpfCnpj',
          })}
        />
      </Col>

      <Col span={24} md={8} lg={6} xl={4}>
        <Input
          value={queryParams?.fantasyName}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, fantasyName: value }))
          }
          placeholder={intl.formatMessage({
            id: 'customers.filters.fantasyName',
          })}
        />
      </Col>

      <Col span={24} md={8} lg={6} xl={4}>
        <Select
          allowClear
          style={{ width: '100%' }}
          value={queryParams?.personType}
          onChange={(value) =>
            setQueryParams((prev) => ({ ...prev, personType: value }))
          }
          placeholder={intl.formatMessage({
            id: 'customers.filters.personType',
          })}
          options={[
            {
              value: 'NATURAL',
              label: intl.formatMessage({
                id: 'customers.filters.personType.options.natural',
              }),
            },
            {
              value: 'LEGAL',
              label: intl.formatMessage({
                id: 'customers.filters.personType.options.legal',
              }),
            },
          ]}
        />
      </Col>

      <Col span={24} md={8} lg={6} xl={4}>
        <Select
          allowClear
          style={{ width: '100%' }}
          value={queryParams?.genderType}
          onChange={(value) =>
            setQueryParams((prev) => ({ ...prev, genderType: value }))
          }
          placeholder={intl.formatMessage({
            id: 'customers.filters.genderType',
          })}
          options={[
            {
              label: intl.formatMessage({
                id: 'customers.filters.genderType.options.man',
              }),
              value: 'MAN',
            },
            {
              label: intl.formatMessage({
                id: 'customers.filters.genderType.options.woman',
              }),
              value: 'WOMAN',
            },
          ]}
        />
      </Col>

      <Col span={24} md={8} lg={6} xl={4}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value,
            }))
          }
        />
      </Col>

      <Col span={24} md={8} lg={6} xl={4}>
        <ActiveExtraFilter
          value={queryParams?.active}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              active: value as unknown as boolean,
            }))
          }
        />
      </Col>

      <Col span={24} md={8} lg={6} xl={4}>
        <Input
          value={queryParams?.contact}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({
              ...prev,
              contact: value,
            }))
          }
          placeholder="Contato"
        />
      </Col>
    </Row>
  );
}

export default CustomersExtraFilters;
